export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100/80 border-t border-background-200/40">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="font-heading text-xl text-primary-400 mb-3 inline-block cursor-pointer">
              90影视
            </a>
            <p className="text-xs text-foreground-500 leading-relaxed mt-2">
              高清超清4K蓝光1080P画质电影电视剧免费在线观看平台，每日更新，无需注册。极致视觉体验，尽在90影视高清频道。
            </p>
          </div>

          <div>
            <h4 className="text-sm text-foreground-800 font-label font-medium mb-3">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '精选推荐', href: '#media' },
                { label: '最新上架', href: '#cards' },
                { label: '热门榜单', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer font-label"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm text-foreground-800 font-label font-medium mb-3">服务支持</h4>
            <div className="space-y-2">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '投稿合作', href: '#contact' },
                { label: '移动观影', href: '#app' },
                { label: '关于我们', href: '#about' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="block text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer font-label"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm text-foreground-800 font-label font-medium mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed font-label">
              诚邀优质影视内容方、技术合作伙伴与广告合作方加入。携手共建高清影视生态，为观众提供更丰富的观影选择。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 font-label">
            &copy; 2026 90影视. 本站所有资源仅供学习交流，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 font-label cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-500 font-label cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="text-xs text-foreground-500 font-label cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}